/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import {
  detailRowStyles,
  groupTotalRowStyles,
  LABOR_REPORT_COLORS,
} from "../labor_report/styles";

export {
  StyledBreadCrumbContainer,
  StyledLink,
  filterContainerStyles,
  selectBaseStyles,
  datePickerStyles,
} from "../classified_discount_records/styles";

export { dropdownMenuProps } from "../perq_report/styles";

export {
  groupSpacerStyles,
  groupBandStyles,
  columnHeaderStyles,
  detailRowStyles,
  negativeCellStyles,
  groupTotalLabelStyles,
} from "../labor_report/styles";

export const stickyTotalFooterStyles = {
  "& tfoot": { position: "sticky", bottom: 0, zIndex: 2 },
};

const FOOTER_RULE = `1px solid ${LABOR_REPORT_COLORS.border}`;

// Rules are drawn by an overlay's own borders: collapsed cell borders stay behind when the
// sticky tfoot lifts, and 1px inset shadows vanish in Firefox below 100% zoom.
export const totalFooterRowStyles = {
  ...groupTotalRowStyles,
  "& .MuiTableCell-root": {
    ...groupTotalRowStyles["& .MuiTableCell-root"],
    position: "relative",
    bottom: "auto",
    zIndex: "auto",
    borderTop: 0,
    borderRight: 0,
    "&::after": {
      content: '""',
      position: "absolute",
      inset: 0,
      pointerEvents: "none",
      borderTop: FOOTER_RULE,
      borderRight: FOOTER_RULE,
    },
    "&:last-of-type": { borderRight: 0 },
    "&:last-of-type::after": { borderRight: 0 },
  },
};

export const blockStartRowStyles = {
  ...detailRowStyles,
  "& .MuiTableCell-root": {
    ...detailRowStyles["& .MuiTableCell-root"],
    borderTop: `1px solid ${LABOR_REPORT_COLORS.border}`,
  },
};

export const blockNameStyles = { fontWeight: 600 };
